import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { ArrowLeft, ArrowRight, Home, Network } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLang } from "../../context/LanguageContext";

export const Brand = ({ sub = true }) => {
  const { t } = useLang();
  return (
    <Link to="/" className="brand" data-testid="brand-home">
      <span className="brand-mark"><Network size={22} /></span>
      <span className="brand-text"><b>RESEARCH</b><em>NETWORK</em>{sub && <span className="brand-sub">{t.brandSub}</span>}</span>
    </Link>
  );
};

export const Header = () => {
  const { t, lang, toggle } = useLang();
  const [, setTick] = useState(0);
  const links = [
    { to: "/", label: t.nav.home, end: true },
    { to: "/opportunities", label: t.nav.opportunities },
    { to: "/achievements", label: t.nav.achievements },
    { to: "/coordinator", label: t.nav.coordinator },
    { to: "/my", label: t.nav.my },
  ];
  const nav = (cls) => (
    <nav className={cls} data-testid="main-navigation">
      {links.map((l, i) => <NavLink to={l.to} end={l.end} key={l.to} data-testid={`nav-link-${i}`} onClick={() => setTick((x) => x + 1)} className={({ isActive }) => (isActive ? "active" : "")}>{l.label}</NavLink>)}
    </nav>
  );
  return (
    <header className="header" data-testid="site-header">
      <div className="container">
        <div className="header-inner">
          <Brand />
          {nav("nav")}
          <div className="header-actions">
            <button className="lang-toggle" onClick={toggle} data-testid="language-toggle">{lang === "ar" ? "EN" : "عربي"}</button>
            <Link to="/opportunities" className="btn btn-primary btn-sm desktop-only" data-testid="nav-register-button">{t.opps.register}</Link>
          </div>
        </div>
        {nav("nav-mobile")}
      </div>
    </header>
  );
};

/** Back bar shown on every page except home. */
export const BackBar = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { t, rtl } = useLang();
  if (pathname === "/") return null;
  const Arrow = rtl ? ArrowRight : ArrowLeft;
  const canGoBack = window.history.length > 1;
  return (
    <div className="container backbar" data-testid="back-bar">
      <button className="mini-btn" onClick={() => (canGoBack ? navigate(-1) : navigate("/"))} data-testid="back-button"><Arrow size={15} />{rtl ? "رجوع" : "Back"}</button>
      <Link to="/" className="mini-btn" data-testid="home-button"><Home size={14} />{t.nav.home}</Link>
    </div>
  );
};
